'use strict';
import * as $j_app$002edata$002e$002dPush$002dNotification$002dData$0024 from "./app.data.-Push-Notification-Data$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$129() {
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$129 as $c_Lapp_api_PharmacyAppUpdate$$anon$129 };
$c_Lapp_api_PharmacyAppUpdate$$anon$129.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$129.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$129;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$129() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$129 as $h_Lapp_api_PharmacyAppUpdate$$anon$129 };
$h_Lapp_api_PharmacyAppUpdate$$anon$129.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$129.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$129.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$129.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dPush$002dNotification$002dData$0024.$m_Lapp_data_PushNotificationData$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$129 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$129, "app.api.PharmacyAppUpdate$$anon$129", ({
  Lapp_api_PharmacyAppUpdate$$anon$129: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$129 as $d_Lapp_api_PharmacyAppUpdate$$anon$129 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$129.js.map
